/* ============================================================
   Ayurjeet — Cart Drawer behaviour
   Open/close, AJAX cart fetch, qty +/-, remove, badge update.
   Renders from /cart.js (single source of truth) on every open
   and after every change, so the drawer is always current.
   ============================================================ */
(function () {
  'use strict';

  var drawer  = document.getElementById('cartDrawer');
  var overlay = document.getElementById('cartDrawerOverlay');
  if (!drawer || !overlay) return;

  var itemsEl    = document.getElementById('cdItems');
  var subtotalEl = document.getElementById('cdSubtotal');
  var countEl    = document.getElementById('cdCount');
  var footerEl   = document.getElementById('cdFooter');
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = false;

  /* ---------- helpers ---------- */
  function money(cents) {
    try {
      return '₹' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    } catch (e) {
      return '₹' + (cents / 100);
    }
  }
  function esc(s) {
    var d = document.createElement('div');
    d.textContent = (s == null) ? '' : s;
    return d.innerHTML;
  }
  function sizedImg(url) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=160';
  }

  /* ---------- open / close ---------- */
  function open() {
    drawer.classList.add('cd-open');
    overlay.classList.add('cd-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cd-lock');
    fetchCart();
  }
  function close() {
    drawer.classList.remove('cd-open');
    overlay.classList.remove('cd-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cd-lock');
  }

  /* ---------- nav badge ---------- */
  function updateBadge(count) {
    var navCart = document.querySelector('.nav-cart');
    if (!navCart) return;
    var badge = navCart.querySelector('.cart-badge');
    if (count > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'cart-badge';
        navCart.appendChild(badge);
      }
      badge.textContent = count;
      badge.style.display = '';
    } else if (badge) {
      badge.style.display = 'none';
    }
  }

  /* ---------- render ---------- */
  function render(cart) {
    updateBadge(cart.item_count);
    if (countEl) countEl.textContent = cart.item_count;
    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);

    if (!cart.items || !cart.items.length) {
      itemsEl.innerHTML =
        '<div class="cd-empty"><p>Your cart is empty.</p>' +
        '<a class="cd-shop" href="' + root + 'collections/all">Shop Now</a></div>';
      if (footerEl) footerEl.style.display = 'none';
      return;
    }
    if (footerEl) footerEl.style.display = '';

    var html = '';
    cart.items.forEach(function (item) {
      var img = sizedImg(item.image);
      var variant = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<div class="cd-variant">' + esc(item.variant_title) + '</div>' : '';
      html +=
        '<div class="cd-item" data-key="' + esc(item.key) + '">' +
          '<a class="cd-item-img" href="' + esc(item.url) + '">' +
            (img ? '<img src="' + esc(img) + '" alt="' + esc(item.product_title) + '" loading="lazy">' : '') +
          '</a>' +
          '<div class="cd-item-main">' +
            '<a class="cd-item-title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
            variant +
            '<div class="cd-item-bottom">' +
              '<div class="cd-qty" data-key="' + esc(item.key) + '">' +
                '<button type="button" class="cd-qty-btn" data-action="dec" aria-label="Decrease quantity">&minus;</button>' +
                '<span class="cd-qty-val">' + item.quantity + '</span>' +
                '<button type="button" class="cd-qty-btn" data-action="inc" aria-label="Increase quantity">+</button>' +
              '</div>' +
              '<span class="cd-item-price">' + money(item.final_line_price) + '</span>' +
            '</div>' +
            '<button type="button" class="cd-remove" data-key="' + esc(item.key) + '">Remove</button>' +
          '</div>' +
        '</div>';
    });
    itemsEl.innerHTML = html;
  }

  /* ---------- AJAX ---------- */
  function fetchCart() {
    itemsEl.classList.add('cd-busy');
    return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); })
      .catch(function () { itemsEl.innerHTML = '<div class="cd-empty"><p>Could not load cart.</p></div>'; })
      .then(function () { itemsEl.classList.remove('cd-busy'); });
  }

  function changeQty(key, qty) {
    if (busy) return;
    busy = true;
    itemsEl.classList.add('cd-busy');
    fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); })
      .catch(function () {})
      .then(function () { busy = false; itemsEl.classList.remove('cd-busy'); });
  }

  /* ---------- events ---------- */
  // qty +/- and remove (delegated)
  itemsEl.addEventListener('click', function (e) {
    var qbtn = e.target.closest('.cd-qty-btn');
    if (qbtn) {
      var wrap = qbtn.closest('.cd-qty');
      var key = wrap.getAttribute('data-key');
      var val = parseInt(wrap.querySelector('.cd-qty-val').textContent, 10) || 1;
      var next = (qbtn.getAttribute('data-action') === 'inc') ? val + 1 : val - 1;
      if (next < 0) next = 0;
      changeQty(key, next);
      return;
    }
    var rm = e.target.closest('.cd-remove');
    if (rm) { changeQty(rm.getAttribute('data-key'), 0); }
  });

  // open: nav cart icon or any [data-cart-drawer-open]
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.nav-cart, [data-cart-drawer-open]');
    if (trigger) {
      e.preventDefault();
      open();
    }
  });

  // close: X, overlay, or any [data-cd-close]
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cd-close]')) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('cd-open')) close();
  });
})();
